import { isTabForward, isTabBackward } from '../../../helpers/focus-helpers'

export const getLayers = (config, isSelected) => {
  const layers = []
  const layer = {
    name: config.id,
    type: config.map_type,
    visible: isSelected,
    mapbox: {
      tileset: config.tileset
    }
  }

  layers.push(layer) //TODO: handle multiple layers per dataset

  return layers
}

export const getFirstForegroundLayerId = map => {
  let firstBoundaryId = ''
  let firstSymbolId = ''

  for (const layer of map.getStyle().layers) {
    if (layer.id.match('admin') && layer.id.match('boundary')) {
      firstBoundaryId = layer.id
      break
    } else if (layer.type === 'symbol') {
      firstSymbolId = layer.id
    }
  }

  return firstBoundaryId || firstSymbolId
}

export const correctTabFlow = mapWrapper => {
  mapWrapper
    .querySelector('.mapboxgl-ctrl-geocoder--input')
    .addEventListener('keydown', e => {
      if (isTabForward(e)) {
        e.preventDefault()
        mapWrapper.querySelector('#map-pane-close').focus()
      } else if (isTabBackward(e)) {
        e.preventDefault()
        mapWrapper.querySelector('.mapboxgl-canvas').focus()
      }
    })

  mapWrapper
    .querySelector('#map-pane-close')
    .addEventListener('keydown', e => {
      if (isTabBackward(e)) {
        e.preventDefault()
        mapWrapper
          .querySelector('.mapboxgl-ctrl-geocoder--input')
          .focus()
      }
    })
}